import { createUseStyles, ComposedTheme } from '@glu/theming';

export const styles = ({
  dataComponents: {
    controlBar: { separatorColor },
  },
}: ComposedTheme) => ({
  auxWrap: {
    lineHeight: '24px',
    borderLeft: `2px solid ${separatorColor}`,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
    marginLeft: 8,
  },
});

export default createUseStyles(styles);
